import { graphql, useStaticQuery } from "gatsby"
import { useImage } from "@hooks/useImage"

const useProductTemplate = () => {
  const { getGatsbyImage } = useImage()

  const { settings, benefits } = useStaticQuery<GatsbyTypes.StaticTemplateProductQuery>(graphql`
    query StaticTemplateProduct {
      settings: sanityTemplateProduct {
        pdpCarouselSettings: _rawPdpCarouselSettings(resolveReferences: { maxDepth: 3 })
        deliveryAndReturns: _rawDeliveryAndReturns(resolveReferences: { maxDepth: 2 })
        giftWrapping: _rawGiftWrapping(resolveReferences: { maxDepth: 8 })
        relatedProductsSettings: _rawRelatedProductsSettings(resolveReferences: { maxDepth: 5 })
        relatedArticlesSettings: _rawRelatedArticlesSettings(resolveReferences: { maxDepth: 5 })
        metadata: _rawMetadata(resolveReferences: { maxDepth: 2 })
        sizeGuideTitle
        sizeGuideContent: _rawSizeGuideContent(resolveReferences: { maxDepth: 2 })
        sizeGuideBlocks {
          sizeHeading
          sizeTable: _rawSizeTable(resolveReferences: { maxDepth: 2 })
        }
        fitAssistantContent: _rawFitAssistantContent(resolveReferences: { maxDepth: 2 })
      }
      benefits: allSanityProductBenefit {
        edges {
          node {
            _key
            title
            description
            tag {
              current
            }
            image: _rawImage(resolveReferences: { maxDepth: 2 })
          }
        }
      }
    }
  `)

  const pdpCarouselSettings = settings?.pdpCarouselSettings

  const keyBenefits: NormalisedKeyBenefit[] =
    benefits?.edges?.map(({ node: benefit }) => ({
      key: benefit?._key,
      title: benefit?.title,
      description: benefit?.description,
      tag: benefit?.tag?.current,
      image: getGatsbyImage(benefit?.image),
    })) || []

  const productDetails = {
    deliveryAndReturns: settings?.deliveryAndReturns,
    giftWrapping: settings?.giftWrapping,
  }

  const relatedConfig = {
    relatedProductsSettings: settings?.relatedProductsSettings,
    relatedArticlesSettings: settings?.relatedArticlesSettings,
  }

  const sizeGuide = {
    title: settings?.sizeGuideTitle,
    content: settings?.sizeGuideContent,
    blocks: settings?.sizeGuideBlocks,
    fitAssistantContent: settings?.fitAssistantContent,
  }

  return { keyBenefits, productDetails, relatedConfig, pdpCarouselSettings, sizeGuide }
}

export default useProductTemplate
